import { render, staticRenderFns } from "./OffersRevampSkeleton.vue?vue&type=template&id=36c87394&scoped=true"
import script from "./OffersRevampSkeleton.vue?vue&type=script&lang=js"
export * from "./OffersRevampSkeleton.vue?vue&type=script&lang=js"
import style0 from "./OffersRevampSkeleton.vue?vue&type=style&index=0&id=36c87394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c87394",
  null
  
)

export default component.exports